import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { OnboardingLayout } from "@/components/layout/OnboardingLayout";
import { Logo } from "@/components/layout/Logo";
import { PrimaryButton, InputField, TextLink } from "@/components/fionova/Primitives";
import { useAuth } from "@/context/AuthContext";

const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

export default function ForgotPassword() {
  const navigate = useNavigate();
  const { forgotPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState("");

  const emailValid = EMAIL_RE.test(email.trim());

  const submit = async () => {
    if (!emailValid || busy) return;
    setBusy(true);
    const msg = await forgotPassword(email.trim());
    setSent(msg);
    setBusy(false);
  };

  return (
    <OnboardingLayout testId="page-forgot" onBack={() => navigate("/login")}>
      <div className="flex flex-col items-center pt-2 text-center">
        <Logo size={72} />
        <h1 className="mt-8 text-3xl font-semibold tracking-tight text-foreground">
          Reset your password
        </h1>
        <p className="mt-3 text-base leading-relaxed text-muted-foreground">
          Enter your email and we'll send you a secure link to set a new password.
        </p>
      </div>

      {sent ? (
        <div className="mt-10 text-center" data-testid="forgot-sent">
          <p className="text-base leading-relaxed text-foreground">{sent}</p>
          <p className="mt-3 text-sm text-muted-foreground">
            The link expires in 1 hour. Check your spam folder if you don't see it.
          </p>
          <div className="mt-8">
            <PrimaryButton data-testid="forgot-back-login" onClick={() => navigate("/login")}>
              Back to log in
            </PrimaryButton>
          </div>
        </div>
      ) : (
        <div className="mt-10 flex flex-col gap-4"
          onKeyDown={(e) => { if (e.key === "Enter" && e.target.tagName === "INPUT") { e.preventDefault(); if (emailValid && !busy) submit(); } }}>
          <InputField
            label="Email" testId="forgot-email" type="email" inputMode="email"
            autoComplete="email" autoCapitalize="none" placeholder="you@example.com"
            value={email} onChange={(e) => setEmail(e.target.value)}
          />
          <PrimaryButton data-testid="forgot-submit" onClick={() => emailValid && !busy && submit()} disabled={!emailValid || busy} className="mt-2">
            {busy ? "Sending…" : "Send reset link"}
          </PrimaryButton>
          <div className="mt-2 text-center">
            <TextLink data-testid="forgot-to-login" onClick={() => navigate("/login")}>
              Remembered it? Log in
            </TextLink>
          </div>
        </div>
      )}
    </OnboardingLayout>
  );
}
